<template>
  <v-dialog
     v-bind="$attrs"
     v-model="showDialog"
     :width="width"
   >
      <template v-slot:default="dialog">
        <v-card>
          <v-card-title class="text-h6">
            {{title}}
          </v-card-title>
          <v-card-text>
             <div class="subtitle-1 pa-2">{{content}}</div>
             <slot name='content'></slot>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="text--disabled" text @click="dialog.value = false">
              取消
            </v-btn>
            <v-btn color="primary" :loading='loading' text @click="submit">
              确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
   </v-dialog>
</template>
<script>
  export default {
    name: 'MaterialSimpleDailog',
    props: {
      title: {
        type: String,
        default: '系统提示'
      },
      content: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: 400
      }
    },
    data () {
      return {
        loading: false,
        showDialog: this.show
      }
    },
    methods: {
      submit () {
        this.loading = true
        this.$emit('on-submit')
      }
    },
    watch: {
      showDialog (val) {
        this.$emit("update:show", val)
        if (!val) {
          this.loading = false
        }
      },
      show (val) {
        this.showDialog = val
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dialog-toolbat-title
</style>
